import { jsx } from "react/jsx-runtime";
import { useRicosTheme, RicosViewer } from "@wix/form-fields";
import styles from "./disabled-form-overlay.module.scss";
const paragraphCustomStylesWUT = {
  p: {
    fontSize: "var(--wix-forms-formParagraphFont-size)",
    fontFamily: "var(--wix-forms-formParagraphFont-family)",
    color: "rgb(var(---wix-forms-formParagraphColor))"
  }
};
const RICOS_THEME = { customStyles: paragraphCustomStylesWUT };
const DisabledFormOverlay = ({
  content,
  isEditor
}) => {
  const customTheme = useRicosTheme(RICOS_THEME);
  if (isEditor || !content) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    RicosViewer,
    {
      content,
      className: styles.disabledFormOverlay,
      customTheme
    }
  );
};
export {
  DisabledFormOverlay
};
//# sourceMappingURL=disabled-form-overlay.js.map
